<template>
  <v-data-table
    :headers="headersByType"
    :loading="!indexedAddresses"
    :items="indexedAddresses"
    :items-per-page="10"
    :server-items-length="meta.total"
    :footer-props="footerProps"
    :options.sync="localOptions"
    :sort-by="sortBy"
    :item-key="itemKey"
  >
    <template v-slot:item.type_id="{ item }">
      {{ item.type.name }}
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('view', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export const BASE = 'base';
export const LINKED = 'linked';

export const types = Object.freeze({
  BASE,
  LINKED
});

export default {
  name: 'AddressesList',

  props: {
    addresses: {
      type: Array,
      default: () => []
    },
    meta: {
      type: Object,
      default: () => ({
        total: -1
      })
    },
    type: {
      type: String,
      default: 'base',
      validator: prop => Object.values(types).includes(prop)
    }
  },

  data: () => ({
    localOptions: {},
    sortBy: 'street',
    itemKey: '_index',
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    },
    columnsByType: {
      base: [0, 1, 2, 5],
      linked: [0, 1, 2, 3, 4, 5]
    }
  }),

  computed: {
    indexedAddresses() {
      return this.addresses.map((item, index) => ({
        _index: index,
        ...item
      }));
    },

    params() {
      const options = this.localOptions;

      return {
        page: options.page,
        per_page: options.itemsPerPage,
        sort_by: options.sortBy[options.sortBy.length - 1],
        order_by: options.sortDesc[options.sortDesc.length - 1] ? 'desc' : 'asc'
      };
    },
    headers() {
      return [
        {
          text: this.$t('ADDRESSES.STREET'),
          value: 'street'
        },
        {
          text: this.$t('ADDRESSES.ZIP.ITEM'),
          value: 'zip'
        },
        {
          text: this.$t('ADDRESSES.CITY'),
          value: 'city'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type_id'
        },
        {
          text: this.$t('LINKED_ADDRESSES.PER_ADDRESS'),
          value: 'per_address'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center',
          width: '10%'
        }
      ];
    },

    headersByType() {
      const columnsIndexes = this.columnsByType[this.type];

      return this.headers.filter((item, index) => {
        return columnsIndexes.indexOf(index) !== -1;
      });
    }
  },

  watch: {
    localOptions: {
      handler() {
        this.$emit('update-params', this.params);
        this.$emit('refresh', {
          params: this.params
        });
      },
      deep: true
    }
  }
};
</script>
